import React, { useState, useEffect } from 'react'
import httpClient from '../../utils/httpClients';
import { useNavigate } from 'react-router-dom';

function Upgrade() {
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [isYearly, setIsYearly] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
const navigate=useNavigate();
  const fetchSubscriptionPlan = async (billingCycle) => {
    try {
      setLoading(true);
      setError(null);
      
      // Fixed the template literal - removed quotes around action variable
      const res = await httpClient.get(`/user/user-subscription/all-plans/${billingCycle}`);
      
      if (res.data.success) {
        setSubscriptionPlans(res.data.data.plans);
      } else {
        setError("Failed to fetch subscription plans");
      }
    } catch (err) {
      console.error("Error fetching subscription plan:", err);
      setError("Error fetching subscription plans. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch monthly plans by default
    fetchSubscriptionPlan('monthly');
  }, []);

 const handleChoosePlan = (plan) => {
  navigate(`/subscription/checkout/${plan._id}`, { 
    state: { plan },
    name: "subscription" // ✅ static value
  });
 };


  const handleBillingCycleChange = (event) => {
    const yearly = event.target.checked;
    setIsYearly(yearly);
    
    // Fetch plans based on selected billing cycle
    const billingCycle = yearly ? 'yearly' : 'monthly';
    fetchSubscriptionPlan(billingCycle);
  };

  const getYearlyPrice = (monthlyPrice) => {
    // Calculate yearly price (monthly price * 12 with some discount logic if needed)
    return monthlyPrice * 12;
  };
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  const renderPlanCard = (plan) => {
    const displayPrice = isYearly ? getYearlyPrice(plan.price) : plan.price;
    const billingPeriod = isYearly ? 'year' : 'month';

    return (
      <div key={plan._id} className="col-md-6 mb-4">
        <div className="card pricing-box-2 mb-lg-0 ">
          <div className="card-body">
            <h3>{plan.name}</h3>
            <h2 className="my-4 pricingtable__highlight">
              <b>
              {plan.price === 0 ? `Free / ${billingPeriod}` : `$${plan.price} / ${billingPeriod}`}
              </b>
            </h2>
            
            <ul className="p-0 mb-0 list-unstyled">
              {plan.features.map((feature, index) => (
                <li key={index}>
                  <p className="mb-4">
                    <svg
                      width={8}
                      className="me-2"
                      viewBox="0 0 8 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx={4} cy={4} r={4} fill="currentColor" />
                    </svg>
                    {feature}
                  </p>
                </li>
              ))}
            </ul>

            {plan.name.includes("Pro") && (
              <div className="type-2">Recommended</div>
            )}
            
            <button type="button" className="btn btn-primary border"        
                   onClick={() => handleChoosePlan(plan)}
>
              Choose
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div className="row mb-5">
          <div className="col-lg-12">
            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div className="row mb-5">
          <div className="col-lg-12">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row mb-5">
        <div className="col-lg-12">
          <div className="card-header">
            <div className="header-title">
              <h2 className="card-title text-capitalize mb-3">Choose Plan</h2>
            </div>
            <div className="card">
              <div className="justify-content-center justify-content-sm-between d-flex card-header border-bottom ">
                <div className="d-flex justify-content-center align-items-center mt-1 mt-sm-0 col-sm-auto">
                  <label className="me-2 form-check-label">Monthly</label>
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      id="contcheckbox"
                      className="form-check-input"
                      checked={isYearly}
                      onChange={handleBillingCycleChange}
                    />
                    <label
                      htmlFor="contcheckbox"
                      className="ms-2 align-top form-check-label"
                    >
                      Yearly
                    </label>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row ">
                  {subscriptionPlans.map(renderPlanCard)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Upgrade;